<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9.913 4.418c.774 0 1.403-.653 1.403-1.459S10.687 1.5 9.913 1.5c-.775 0-1.404.653-1.404 1.46 0 .805.629 1.458 1.404 1.458Zm-3.392 7.937c-.041.467-1.774 2.89-2.021 3.328l1.224.817c.319-.446 1.14-1.579 1.444-2.017.252-.364.568-.754.74-1.186.087-.235.185-.522.286-.826l-1.132-1.758c-.194.588-.43 1.304-.54 1.642Z"/>
    <path d="M10.463 8.79c.06.096.148.177.26.228l2.248 1.03.529-1.044-2.005-1.066c-.433-.703-1.124-1.842-1.51-2.464-.197-.334-.642-.508-1.005-.472-.407-.061-1.285.127-1.653.49L5.514 6.82a.616.616 0 0 0-.247.42l-.37 2.929 1.169.173.467-2.633 1.173-.86-.272 2.018a2.168 2.168 0 0 0 .317 1.45l3.898 6.162 1.253-.774-3.428-5.418.412-2.439.577.941Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
